import {
  PlacementTest,
  StudentPlacementTestAnswer,
  SubmitPlacementTest,
} from "../types/PlacementTest";
import api from "./api";

export const createPlacementTest = async () => {
  try {
    const response = await api.post("students/start-placement-test", {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error saving placementTest:", error);

    throw error;
  }
};

export const finshPlacementTest = async (
  data: StudentPlacementTestAnswer[]
) => {
  try {
    const response = await api.post(
      "students/complete-placement-test",
      { answers: data },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error submitting placementTest:", error);

    throw error;
  }
};

export const savePlacementTestProgress = async (
  data: StudentPlacementTestAnswer[]
) => {
  try {
    api.post(
      "students/save-placement-test-progress",
      { answers: data },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    console.error("Error saving placementTest:", error);
    throw error;
  }
};

export const getPlacementTests = async () => {
  try {
    const response = await api.get("/placement-tests");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch placement tests", error);
    throw error;
  }
};
